import React, { createContext, useState } from "react";

interface ModalProviderProps {
  children: React.ReactNode;
}

interface ModalContextProps {
  isModalOpen: boolean;
  hideModal: (data: { modalName: string; modalData?: Record<string, unknown> }) => void;
  showModal: (data: { modalName: string; modalData?: Record<string, unknown> }) => void;
  modalName?: string;
  modalData?: Record<string, unknown>;
  updateLocalSection?: (sectionTag: string, updatedSection: any) => void;
  localSections?: Record<string, any>;
}

// eslint-disable-next-line react-refresh/only-export-components
export const ModalContext = createContext<ModalContextProps>({
  isModalOpen: false,
  hideModal: () => null,
  showModal: () => null,
  modalName: "",
  modalData: {},
  updateLocalSection: undefined,
  localSections: undefined
});

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalName, setModalName] = useState("");
  const [modalData, setModalData] = useState<Record<string, unknown>>({});

  const hideModal = (data: { modalName?: string; modalData?: Record<string, unknown> }) => {
    setIsModalOpen(false);
    setModalName(data.modalName ?? "");
    setModalData(data.modalData ?? {});
  };

  const showModal = (data: { modalName: string; modalData?: Record<string, unknown> }) => {
    setIsModalOpen(true);
    setModalName(data.modalName);
    setModalData(data.modalData ?? {});
  };

  return (
    <ModalContext.Provider value={{ isModalOpen, hideModal, showModal, modalName, modalData }}>
      {children}
    </ModalContext.Provider>
  );
};
